import script from "./errorTips.vue?vue&type=script&setup=true&lang=js"
export * from "./errorTips.vue?vue&type=script&setup=true&lang=js"

import "./errorTips.vue?vue&type=style&index=0&id=670e5e00&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670e5e00"]])

export default __exports__